<template>
  <div>
    <section v-if="loading">
      <div class="loader"></div>
    </section>
    <section v-else>
      <template>
        <div class="row group-section mb-1 " >
          <template>
            <div class="col-md-2 mt-10 ">
              <label class=" d-flex align-items-center"> Show
                <select style="width: 60px;" class="custom-select mr-2 ml-2 custom-select-sm form-control form-control-sm datatable-dropdown" id="grouped"  aria-describedby="grouped" required v-model="pageSize">
                  <option value="10" >10</option>
                  <option value="25" >25</option>
                  <option value="50" >50</option>
                  <option :value="paginatedGroups.length" >All</option>
                </select> entries</label>
            </div>
            <div class="col-md-12 mt-2">
              <table :id="`${datatableId}-ungrouped`" class="table table-striped single-outage-table table-responsive">
                <thead>
                <tr>
                  <th></th>
                  <th class="text-center">Tag</th>
                  <th class="text-center">Test Name
<!--                    <i v-if="!planSortType || planSortType==='desc'" class="fa fa-sort-down" :class="planSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedPlanSort()" />-->
<!--                    <i v-if="!planSortType || planSortType==='asc'"  class="fa fa-sort-up " :style="!planSortType?'margin-left:-7px':'' "  :class="planSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedPlanSort()" />-->
                  </th>
                  <th class="text-center">Server IP
<!--                    <i v-if="!ipSortType || ipSortType==='desc'" class="fa fa-sort-down" :class="ipSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedIpSort()" />-->
<!--                    <i v-if="!ipSortType || ipSortType==='asc'"  class="fa fa-sort-up " :style="!ipSortType?'margin-left:-7px':'' "  :class="ipSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedIpSort()" />-->
                  </th>
                  <th class="text-center">Cause</th>
<!--                  <th>Out ages-->
<!--                    <i v-if="!outageSortType || outageSortType==='desc'" class="fa fa-sort-down" :class="outageSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedOutageSort()" />-->
<!--                    <i v-if="!outageSortType || outageSortType==='asc'"  class="fa fa-sort-up " :style="!outageSortType?'margin-left:-7px':'' "  :class="outageSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedOutageSort()" />-->
<!--                  </th>-->
                  <th class="text-center" width="18%">Note</th>
                  <th class="text-center">Plan</th>
                  <th class="text-center">Ticket</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Action</th>
                  <th class="text-center">Acknowledge</th>
                </tr>
                </thead>
                <tbody v-for="(test, index) in getWPOGroup" :key="index">
                <tr class="'bg-light'">
                  <td width="1%">
                    <div class="dropdown m-auto">
                      <button title="Choose Operation" class="btn settinds-btn btn-sm dropdown-toggle" data-bs-display="static" style="width: 15px!important; padding: 0!important;" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-cog"></i>
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(test)">Delete</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>
                        <a v-if="test.uid" class="dropdown-item" href="javascript:void(0)" @click=" findUser(test)">Login User</a>
                        <router-link v-if="test.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: test.uid } }">Edit User</router-link>
                      </div>
                    </div>
                  </td>
                  <td class="text-center" width="5%">
                    <img style="width: 20px !important;" src="../../../assets/img/disk.png" alt="">
                  </td>
                  <td class="text-center domain"  width="20%">
                    <div>
                      {{showDomainName(test.url)}}
                    </div>
                  </td>
                  <td width="3%" class="text-center" @click="doCopy(test.serverIP)">{{ test.serverIP }}</td>
                  <template v-if="test.incidents[test.incidents.length - 1].cause">
                    <td class="text-center" width="10%" v-if="test.incidents[test.incidents.length - 1].cause.length > causeLength" >
                      <span v-if="!getProperty(test.id)">
                       {{test.incidents[test.incidents.length - 1].cause.slice(0,causeLength) }}
                       <a  href="javascript:void(0)"  @click="changeCauseLength(test)"> more</a>
                      </span>
                      <template v-else>
                        {{test.incidents[test.incidents.length - 1].cause }}
                        <a  href="javascript:void(0)"  @click="changeCauseLength(test)"> less</a>
                      </template>
                    </td>
                    <td class="text-center" width="10%" v-else>{{test.incidents[test.incidents.length - 1].cause }}</td>
                  </template>
                  <template v-else>
                    <td width="10%">{{test.incidents[test.incidents.length - 1].cause }}</td>
                  </template>
                  <td width="8%" class="cursor-pointer domain text-center" @click="openModal(test, 'addNoteModal')" :title="getNoteTooltip(test)">{{(test.note && test.note !== '') ? test.note : 'N/A'}}</td>
                  <td width="8%" class="text-center">{{test.wpoPlan}}</td>
                  <td width="4%" class="text-center">
<!--                    <template v-if="getAcknowledgeBy(test) && (getAcknowledgeBy(test) === `${user.firstName} ${user.lastName}`)">-->
<!--                      <i v-if="loadingOfTicket.flag && loadingOfTicket.id === test.id" class="fa fa-spin mr-2 text-primary fa-spinner"></i>-->
<!--                      <i v-else @click="openTicketModal(test, 'ticketIcon')" data-toggle="tooltip" data-placement="top" data-html="true" title="1-Click Ticket" class="fa fa-ticket text-primary mr-2 make-cursor-pointer"></i>-->
<!--                    </template>-->
                    <i @click="openModal(test, 'addTicketModal')" title="Edit ticket"  data-toggle="tooltip" data-placement="top" :key="test.url+'editTicket321'" data-html="true" class="text-primary fa fa-pencil cursor-pointer"></i>
                    <a  v-if="test.ticket_url" :href="test.ticket_url" target="_blank">
                      <i title="View Ticket" :class="test.ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"></i>
                    </a>
                  </td>
                  <td :style="getStatusStyle(test.currentTicket ? test.currentTicket.status : '')" class="text-center fw-600">{{test.currentTicket ? test.currentTicket.status : ''}}</td>
                  <td width="8%">
                    <select :key="test.id" style="height: 31px; min-width: 70px; max-width: 190px" class="form-control" v-model="dropdownVal" @change="onActionChange(test, $event)">
                      <!--                    <option></option>-->
                      <option disabled value="select">Select</option>
                      <option value="openTicket">Open Ticket</option>
                      <option value="modifyDisk">Modify Disk</option>
                      <option value="resolve">Resolve</option>
                    </select>
                  </td>
                  <td width="2%" class="text-center">
                    <template>
                      <span v-if="getAcknowledgeBy(test)">
                        <img data-toggle="tooltip" data-placement="top" data-html="true" width="35%" style="border-radius: 50%;" :title="getAcknowledgeBy(test)" :src="`https://www.gravatar.com/avatar/${getHash(test.acknowledgedBy)}?s=50`">
                        <!--												{{// test.acknowledgedBy}}-->
                      </span>
                      <template v-else-if="test.status === 'down'">
                        <button @click="acknowledge(test)" :disabled="selectedMonitorLoading && selectedMonitorLoading === test.id" type="button" class="btn btn-primary btn-sm">
                          <span v-if="selectedMonitorLoading && selectedMonitorLoading === test.id">
                            <div class="loader mini_loader"></div>
                          </span>
                          <span v-else>
                            Check In
                          </span>
                        </button>
                      </template>

                    </template>
                  </td>
                </tr>
                </tbody>
                <tbody v-if="getWPOGroup.length === 0">
                <tr class="'bg-light'" >
                  <td width="30%" class="text-center text-danger" colspan="11">No {{(status === 'Up') ? 'Recent' : 'Current'}} Disk Alerts Exist!</td>
                </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
        <div class="row mt-2" v-if="getWPOGroup.length > 0">
          <div class="col-md-12 text-center">
                    <span class="lh-3 pull-left">
                        Page {{this.pageNumber + 1}} of {{pageCount}}
                    </span>
            <section class="dataTables_paginate paging_full_numbers">
              <paginate
                  :pageCount="pageCount"
                  :clickHandler="goToPage"
                  :prevText="'Prev'"
                  :nextText="'Next'"
                  page-class="page-item"
                  prev-class="page-item"
                  prev-link-class="page-link"
                  next-class="page-item"
                  next-link-class="page-link"
                  page-link-class="page-link"
                  containerClass="pagination">
              </paginate>
            </section>
          </div>
        </div>
<!--        <div class="customer-list-info" v-if="getWPOGroup.length === 0">-->
<!--          <div class="card-text text-center text-danger mb-3 font-weight-bold">-->
<!--            No {{(status === 'Up') ? 'Recent' : 'Current'}} Disk Alerts Exist!-->
<!--          </div>-->
<!--        </div>-->
      </template>
    </section>
    <div class="modal" tabindex="-1" role="dialog" id="modifyDisk" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title text-center">Modify Disk</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="!diskInfo.loading" class="modal-body">
            <div class="form-group">
              <label>SolusVm VPS ID</label>
              <input disabled class="form-control" type="text" v-model="diskInfo.solusVmId">
            </div>
            <div class="form-group">
              <label>Node</label>
              <input disabled class="form-control" type="text" v-model="diskInfo.nodeName">
            </div>
            <div class="form-group">
              <label>Free Disk</label>
              <input disabled class="form-control" type="text" v-model="diskInfo.freedisk">
            </div>
            <div v-if="typeof (diskInfo.hdd) !== undefined" class="form-group">
              <label>SolusVM Disk Space (GB)</label>
              <div class="col-sm-10 col-md-6 col-lg-6 pl-0">
                <div class="input-group d-flex align-items-center">
                  <input type="text" class="form-control" name="used" readonly :value="(diskInfo.hdd.used / Math.pow(1024, 3)).toFixed(2) + ' GB'" />
                  <b class="mt-2 ml-5 mr-5">OF</b>
                  <input v-if="diskInfo.default" type="text" class="form-control" name="total" readonly :value="(diskInfo.hdd.total / Math.pow(1024, 3)).toFixed(2) + ' GB'"  />
                  <input v-else type="text" class="form-control" name="total" v-model="diskInfo.newHdd"  />
                  <div v-if="diskInfo.default" style="height: 37px;" class="input-group-append">
                    <button style="margin: 0" data-toggle="modal" data-target="#changeHddModal" class="btn btn-primary btn-sm" @click="diskInfo.newHdd = (diskInfo.hdd.total / Math.pow(1024, 3)).toFixed(2); diskInfo.default = false" type="button"><i class="fa fa-pencil"></i></button>
                  </div>
                  <template v-else>
                    <div style="height: 37px;" class="input-group-append">
                      <button style="margin: 0" data-toggle="modal" data-target="#changeHddModal" class="btn btn-primary btn-sm" @click="updateHdd()" type="button"><i v-if="!diskInfo.updateHdLoading" class="fa fa-save"></i><i v-else class="fa fa-spin fa-spinner"></i></button>
                      <button style="height: 37px;margin: 0" class="btn btn-danger ml-5 btn-sm" @click="diskInfo.default = true" type="button"><i class="fa fa-ban"></i></button>
                    </div>
                  </template>

                </div>
              </div>
            </div>
          </div>
          <div v-else class="modal-body">
            <div class="loader"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import _ from "lodash";
import dateMixin from '../../../mixins/dateMixin'
import loginAsMixin from "../../../mixins/loginAsMixin";
import statisticsMixin from "../../../mixins/statisticsMixin";
import AdminLogs from "@/mixins/adminLogs";
import moment from "moment";
import swal from "sweetalert2";
import {db} from "@/firebase/init";
import Paginate from 'vuejs-paginate'
import md5 from "crypto-js/md5";
import axios from "axios";
import plan from "@/store/modules/plan";
import tempDomainModal from "@/components/Admin/Tasks/showTempDomainModal.vue";



export default {
  name: "BetterUptimeTable",
  props: ["datatableId", "status" , 'searchQuery', 'presetMacros', 'tableType', 'ticketLoading'],
  mixins: [dateMixin, loginAsMixin, statisticsMixin, AdminLogs],
  components: {
    tempDomainModal, Paginate,
  },

  data() {
    return {
      diskInfo: { hdd: {}, default: true},
      dropdownVal: 'select',
      loadingOfTicket: { flag: false, id: null},
      selectedFilters: [{ tag: 'all', text: 'All Tags'},
        { tag: 'cloudflare', category: 'service', src: require('@/assets/img/cloudflare.png') },
        { tag: 'ezoic', category: 'cache', src: require('@/assets/img/ezoic_cache.png') },
        { tag: 'sucuri', category: 'service', src: require('@/assets/img/sucuri.png') },
        { tag: 'bigscoots', category: 'cfe', src: require('@/assets/img/bigscoots_cf.png') },
        { tag: 'squarespace',category: 'host', src: require('@/assets/img/squarespace.png') },
        { tag: 'nerdpress',category: 'cfe', src: require('@/assets/img/nerdpress.png') },
        { tag: 'ezoic', category: 'ads', src: require('@/assets/img/ezoic_ADS.png') },
        { tag: 'wix', category: 'host', src: require('@/assets/img/wix.png') },
        { tag: 'bigscoots', category: 'host', src: require('@/assets/img/bigscoots.jpg') },
        { tag: 'shopify', category: 'host', src: require('@/assets/img/shopify-tag.png') },
        { tag: 'none', text: 'No Tags'}
      ],
      allFilterSelected: false,
      notInWPOFilter: true,
      filteredOptions: [
        { tag: 'all', text: 'All Tags'},
        { tag: 'cloudflare', category: 'service', src: require('@/assets/img/cloudflare.png') },
        { tag: 'ezoic', category: 'cache', src: require('@/assets/img/ezoic_cache.png') },
        { tag: 'sucuri', category: 'service', src: require('@/assets/img/sucuri.png') },
        { tag: 'bigscoots', category: 'cfe', src: require('@/assets/img/bigscoots_cf.png') },
        { tag: 'squarespace',category: 'host', src: require('@/assets/img/squarespace.png') },
        { tag: 'nerdpress',category: 'cfe', src: require('@/assets/img/nerdpress.png') },
        { tag: 'ezoic', category: 'ads', src: require('@/assets/img/ezoic_ADS.png') },
        { tag: 'wix', category: 'host', src: require('@/assets/img/wix.png') },
        { tag: 'bigscoots', category: 'host', src: require('@/assets/img/bigscoots.jpg') },
        { tag: 'shopify', category: 'host', src: require('@/assets/img/shopify-tag.png') },
        { tag: 'none', text: 'No Tags'},
      ],
      tracker: {},
      affectedNodes: [],
      affectedRacks: [],
      openedGroups: [],
      loading: false,
      tests: [],
      testGroups:[],
      domainDateTime: {},
      totalDownTests: 0,
      totalDownServices: 0,
      totalPausedTests: 0,
      totalPendingTests: 0,
      totalSuspendedTests: 0,
      allNodes: {},
      planSortType: null,
      ipSortType: null,
      outageSortType: null,
      nodeSortType: null,
      rackSortType: null,
      pageNumber: 0,
      updateItem: null,
      action: null,
      pageSize: 10,
      removeItem: null,
      statusSortType: 'asc',
      downtimeType: null,
      statusList: [],
      selectedMonitorLoading: null,
      selectedPlanLoading: null,
      causeLength: 33,
      activeJobsDomainList: [],
      activeMigrationList: [],
      completedJobsDomainList: [],
      pendingJobListener : null,
      completeJobListener : null,
      migrationListener : null,
      allMembers: []
    }
  },
  mounted(){
    this.pendingJobs();
    this.activeMigrations();
    this.completedJobs();
    this.getStatusList()
    this.getAllNodes();
    this.getAdmins()
    // $(function () {
    //   $('[data-toggle="tooltip"]').tooltip()
    // })
  },
  computed:{
    user() {
      return this.$store.getters.user;
    },
    pageCount(){
      let filteredGroups = this.paginatedGroups
      let l = filteredGroups.length, s = this.pageSize;
      return Math.ceil(l/s);
    },
    getNonWPOGroup(){
      return this.paginatedGroups.filter(el => el.planName==='(N/A)')
    },
    getSuspendedGroup(){
      return this.paginatedGroups.filter(el => {
        if (el.planName==='Suspended') {
          el.showTests = true;
          return true
        }
      })
    },
    getWPOGroup(){
      console.log('a', this.paginatedGroups)
      let array= this.paginatedGroups
      console.log('array', array)
      if(this.planSortType === 'asc'){
        console.log('in type')
        array.sort((a, b) => {
          if (a.planName.toLowerCase() > b.planName.toLowerCase()) {
            return 1
          }
          if (a.planName.toLowerCase() < b.planName.toLowerCase()) {
            return -1
          }
          return 0
        });
      } else if(this.planSortType === 'desc'){
        array.sort(function(a, b){
          if (a.planName.toLowerCase() < b.planName.toLowerCase()) {
            return 1
          }
          if (a.planName.toLowerCase() > b.planName.toLowerCase()) {
            return -1
          }
          return 0
        });
      }
      if(this.ipSortType === 'asc'){
        array.sort((a, b) => {
          if (a.serverIP > b.serverIP) {
            return 1
          }
          if (a.serverIP < b.serverIP) {
            return -1
          }
          return 0
        });
      } else if(this.ipSortType === 'desc'){
        array.sort(function(a, b){
          if (a.serverIP < b.serverIP) {
            return 1
          }
          if (a.serverIP > b.serverIP) {
            return -1
          }
          return 0
        });
      }
      const start = this.pageNumber * this.pageSize, end = start + this.pageSize;
      return array.slice(start, end);
    },
    paginatedGroups(){
      let filteredGroups = this.tests.filter(el => el.type === 'diskAlert');
      // if(this.searchQuery) {
      //   filteredGroups = filteredGroups.filter(g => {
      //     g.url.toLowerCase().includes(this.searchQuery.toLowerCase())
      //   })
      // }
      console.log('groups', filteredGroups)
      return filteredGroups.filter(el => el.url.includes(this.searchQuery))
    },
  },
  watch: {
    paginatedGroups() {
      // Justin asked not to change the pagesize
      // this.pageNumber = 0;
      // this.pageSize= 10
    },
    getWPOGroup() {
      console.log(`changed`)
      $('[data-toggle="tooltip"]').tooltip('dispose');
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    },
    ticketLoading(val) {
      console.log(`im ticket loading ${val.toString()}`);
      this.loadingOfTicket = val;
    }
  },
  created(){
    if(this.status !== 'Up'){
      setInterval(() => this.startClockTicking(), 1000);
    }
  },
  methods: {
    async syncVPSDetails(account) {
      console.log(account);
      let vmId = '';
      try{
        const accountResp = await this.$http.post('/solus-vm/fetch_client_accounts', {
          clientId: account.hbServiceID,
          grant_type: 'token'
        });
        if(accountResp.data.hbAccounts){
          const hbAccountDetails = accountResp.data.hbAccounts;
          const accountRef = await db.collection('hostingAccounts').doc(account.uid).get();
          const {accounts} = accountRef.data();
          accounts[account.planIndex].primary.solusVM_VPS_ID = (!hbAccountDetails.extra_details.option6) ? '' : hbAccountDetails.extra_details.option6;
          accounts[account.planIndex].primary.hbHostname = hbAccountDetails.domain;
          accounts[account.planIndex].primary.hbServiceID = account.hbServiceID;
          await db.collection('hostingAccounts').doc(account.uid).update({
            accounts: accounts
          });
          vmId = hbAccountDetails.extra_details.option6;
          try {
            const accMapRef = await db.collection('account-hb')
                .where('uid', '==', account.uid)
                .where('domain', '==', accounts[account.planIndex].primary.domain)
                .get();
            if (accMapRef.size > 0) {
              await db.collection('account-hb')
                  .doc(accMapRef.docs[0].id)
                  .update({
                    hbServiceID: account.hbServiceID,
                    solusVM_VPS_ID: (!hbAccountDetails.extra_details.option6) ? '' : hbAccountDetails.extra_details.option6,
                    hbHostname: hbAccountDetails.domain,
                  });
            }
          } catch (e) {
            console.log(e.toString())
            this.addLog({
              message: e.toString(),
              level : 'danger'
            })
          }
        }else{
          this.addLog({
            message:accountResp.data.message,
            level : 'danger'
          })
          swal('Error!', accountResp.data.message, 'error');
        }
        if(vmId) {
          const nodeInfoResp = await this.$http.post('/solus-vm/fetch_node_info', {
            vmId: vmId,
            grant_type: 'token'
          });
          if(nodeInfoResp.data.status === 'success') {
            const hddInfo = nodeInfoResp.data.hdd.split(',');
            const accountRef = await db.collection('hostingAccounts').doc(account.uid).get();
            const {accounts} = accountRef.data();
            accounts[account.planIndex].primary.hdd = {
              total: hddInfo[0],
              used: hddInfo[1],
              free:hddInfo[2],
              usedPercent: hddInfo[3]
            };
            await db.collection('hostingAccounts').doc(account.uid).update({
              accounts: accounts
            })
            await this.$http.post('/algolia/reinitialize-user-all-record', {
              grant_type: 'token',
              uid : account.uid,
            });
            await this.addLog({
              uid: this.docID,
              primaryPlan: accounts[account.planIndex].primary.domain,
              message: 'User has Synchronized Service Details!',
              level: "info"
            });
          }else {
            this.addLog({
              message:nodeInfoResp.data.message,
              level : 'danger'
            })
            swal('Error!', nodeInfoResp.data.message, 'error');
          }
        }else{
          const accountRef = await db.collection('hostingAccounts').doc(account.uid).get();
          const {accounts} = accountRef.data();
          accounts[account.planIndex].primary.hdd = '';
          await db.collection('hostingAccounts').doc(account.uid).update({
            accounts: accounts
          })
          await this.addLog({
            uid: this.docID,
            primaryPlan: accounts[account.planIndex].primary.domain,
            message: 'User has Synchronized Service Details!',
            level: "info"
          });
        }
      }catch (err) {
        console.error(err);

        this.addLog({
          uid: this.docID,
          message: 'Error in synchronizing Service Details!',
          level: "error"
        });
        swal('Error!', err.response.data.message, 'error');
      }
    },
    async updateHdd() {
      this.diskInfo.updateHdLoading = true
      const used = this.diskInfo.hdd.used;
      const vmId = this.diskInfo.solusVmId;
      try{
        const usedInGB = parseFloat((used / Math.pow(1024, 3)).toFixed(1));
        const usedBuffer = parseFloat((usedInGB * 0.10).toFixed(1)); // 10% buffer
        const finalComparisonWithUsed = usedInGB + usedBuffer;
        console.log(this.diskInfo.newHdd, finalComparisonWithUsed);
        if(parseFloat(this.diskInfo.newHdd) < parseFloat(finalComparisonWithUsed)) {
          swal('Error!', 'Disk space must be greater than used space!', 'error');
          return;
        }
        const changeHDDResp = await this.$http.post('/solus-vm/change_hdd', {
          vmId: vmId,
          newHdd: parseFloat(this.diskInfo.newHdd),
          grant_type: 'token'
        });
        await this.syncVPSDetails(this.diskInfo);
        swal('HDD Changed!', changeHDDResp.data.message, 'success');
        await this.addLog({
          uid: this.docID,
          message: 'User has Updated Disk Space of SolusVM VPS! Account: ',
          level: "info"
        });
        $('#modifyDisk').modal('hide')
      }catch (err) {
        await this.addLog({
          uid: this.docID,
          message: 'Error in updating Disk Space of SolusVM VPS! Account: ',
          level: "error"
        });
        console.error(err);
        swal('Error!', err.response.data.message, 'error');
      } finally {
        this.diskInfo.updateHdLoading = false
      }
    },
    getStatusStyle(status = '') {
      let style = '';
      if(status === 'Requires Customer Update') {
        style = 'color: #d19600;'
      } else if(status === 'Answered') {
        style = 'color: #4867'
      } else if(status === 'In-Progress') {
        style = 'color: #363636'
      } else if(status === 'Sales Followup') {
        style = 'color: #2c82c6'
      } else if(status === 'Client-Reply' || status === 'Waiting on Billing') {
        style = 'color: #cf0f34'
      } else if(status === 'Closed') {
        style = 'color: #363636'
      } else if(status === 'Open') {
        style = 'color: #7957d5'
      }
      return style;
    },
    async getSolusVmInfo(acc) {
      this.diskInfo.loading = true;
      this.diskInfo = {...this.diskInfo, ...acc}
      // get node info from the domain collection
      const ref = await db.collection('domains').where('domain', '==', acc.url).where('ip', '==', acc.serverIP).get()
      console.log(`ref size ${ref.size}`)
      if (ref.size) {
        const data = ref.docs[0].data()
        console.log(`dataa of node ${data.netboxNodeId}`)
        if (data.netboxNodeId) {
          console.log('found')
          const netbox = await db.collection('netboxNodes').doc(data.netboxNodeId.toString()).get()
          console.log(netbox.data())
          if(netbox.exists) {
            const {freedisk, solusvm_node_id, name} = netbox.data()
            this.diskInfo = {
              ...this.diskInfo,
              freedisk: Math.floor(Number(freedisk) / (1024 * 1024)),
              nodeName: name,
              solusVmId: solusvm_node_id
            }
          }
        }
        const hostingAcc = await db.collection('hostingAccounts').doc(acc.uid).get()
        if(hostingAcc.exists) {
          const { accounts } = hostingAcc.data();
          const obj = accounts.find(el => el.primary.serverIP === acc.serverIP);
          if(obj) {
            this.diskInfo.hbServiceID = obj.primary.hbServiceID
            this.diskInfo.planIndex = accounts.findIndex(el => el.primary.serverIP === acc.serverIP);
            console.log(`obj ${JSON.stringify(obj.primary.hdd)}`)
            if(obj.primary.hdd && typeof (obj.primary.hdd) !==undefined) {
              this.diskInfo.hdd = obj.primary.hdd || undefined;
              this.diskInfo.newHdd = (obj.primary.hdd.total / Math.pow(1024, 3)).toFixed(2)
              this.diskInfo.customHdd = {used: (obj.primary.hdd.used / Math.pow(1024, 3)).toFixed(2), total: (obj.primary.hdd.total / Math.pow(1024, 3)).toFixed(2)}
            }
          }
        }
      }
      this.diskInfo.loading = false;
    },
    async onActionChange(test, e) {
      console.log('target value', e.target.value)
      const {value} = e.target
      if(value === 'openTicket') {
        this.openTicketModal(test, 'diskAlert')
      } else if(value === 'resolve') {
        test.incidents[test.incidents.length - 1].resolvedBy = `${this.user.firstName} ${this.user.lastName}`
        test.incidents[test.incidents.length - 1].end = new Date().toISOString()
        test.incidents[test.incidents.length - 1].status = 'up'
        await db.collection('monitors').doc(test.id).update({ incidents: test.incidents, status: 'up', updatedAt: new Date().toISOString()})
      } else if(value === 'modifyDisk') {
        this.getSolusVmInfo(test)
        $('#modifyDisk').modal('show');
        $('.modal-backdrop').removeClass("modal-backdrop");
      }
      this.dropdownVal = 'select'
    },
    getHash(nam){
      const obj = this.allMembers.find(el => `${el.firstName} ${el.lastName}` === nam);
      let hash = ''
      if(obj){
        hash = md5(obj.email.trim().toLowerCase()).toString()
      }
      return hash
    },
    async getAdmins() {
      const ref = await db.collection("users").where("userType", "in", ['admin', 'manager', 'super-admin']).get();
      if(ref.size) {
        ref.forEach(el => {
          this.allMembers.push({uid: el.id, ...el.data()})
        })
      }
    },
    getWPOPlan(group) {
      const plan = group.tests.find(el => el.wpoPlan);
      return  plan ? plan.wpoPlan : ''
    },
    getActiveJobTitle (test) { //  'Active backup CREATE process running': 'Active backup RESTORE process running'
      const domain = this.showDomainName(test.url)
      if (test.taskResolvedAt) {
        const dateObject = new Date(test.taskResolvedAt);

        // Get current time
        const currentTime = new Date();

        // Calculate the time difference in milliseconds
        const timeDifference = currentTime - dateObject;

        // Convert time difference to hours
        const minutesDifference = timeDifference / (1000 * 60);
        if (minutesDifference <= 60) {
          return `Possible DNS propagation or SSL issue. Site was added ${Math.ceil(minutesDifference)} minutes ago.`
        }
      }
      const activeM = this.activeMigrationList.find(el => el.domain === domain)
      if (activeM) {
        return 'Active migration request exists in WPO.'
      }
      const activeJob = this.activeJobsDomainList.find(el => (el.jobName !== 'set-php-version' && el.jobData.ip === test.serverIP))
      if (activeJob) {
        switch (activeJob.jobName) {
          case 'backup-job':
            return activeJob.operation === 'create' ? 'Active Backup CREATE process running' : 'Active Backup RESTORE process running'
          case 'staging-job':
            return 'Active STAGING job running'
          case 'cloning':
            return 'Active CLONE job running'
          case 'set-php-version':
            return `Potential PHP version conflict. PHP Version was updated to ${activeJob.jobData.phpVersion} from ${activeJob.jobData.prevPhpVersion} - ${moment(new Date(activeJob.createdAt)).fromNow()}.`
          default:
            return ''
        }
      }
    },
    getPhpJobTitle (test) { //  'Active backup CREATE process running': 'Active backup RESTORE process running'
      const domain = this.showDomainName(test.url)
      const activeJob = this.activeJobsDomainList.find(el => (el.jobName === 'set-php-version' && el.domain === domain))
      if (activeJob) {
        switch (activeJob.jobName) {
          case 'set-php-version':
            return `Potential PHP version conflict. PHP Version was updated to ${activeJob.jobData.phpVersion} from ${activeJob.jobData.prevPhpVersion} - ${moment(new Date(activeJob.createdAt)).fromNow()}.`
          default:
            return ''
        }
      } else {
        const lastIncident = test.incidents[test.incidents.length - 1]
        if (!lastIncident.start) {
          return
        }
        const date = lastIncident.start
        let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
        const obj1 = this.completedJobsDomainList.find(el => {
          return el.jobName === 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate60Min) && (el.domain === domain)
        })
        if (obj1) {
          return `Potential PHP version conflict. PHP Version was updated to ${obj1.jobData.phpVersion} from ${obj1.jobData.prevPhpVersion} - ${moment(new Date(obj1.createdAt)).fromNow()}.`
        }
      }
    },
    getCompletedJobTitle (test) { //  'Active backup CREATE process running': 'Active backup RESTORE process running'
      let domain = this.showDomainName(test.url);
      const lastIncident = test.incidents[test.incidents.length - 1]
      if (!lastIncident.start) {
        return
      }
      const date = lastIncident.start
      let earlierDate = new Date(new Date(lastIncident.start).getTime() - (30 * 60 * 1000)).toISOString();
      let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
      const job = this.completedJobsDomainList.find(el => {
        return el.jobName !== 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate) && (el.jobData.ip === test.serverIP)
      })
      if (job) {
        switch (job.jobName) {
          case 'backup-job':
            return job.operation === 'create' ? 'Backup CREATE process was running' : 'Backup RESTORE process was running'
          case 'staging-job':
            return 'STAGING job was running'
          case 'cloning':
            return 'CLONE job was running'
          case 'set-php-version':
            return `Potential PHP version conflict. PHP Version was updated to ${job.jobData.phpVersion} from ${job.jobData.prevPhpVersion} - ${moment(new Date(job.createdAt)).fromNow()}.`
          default:
            return ''
        }
      }
    },
    checkActiveJob (test) {
      let domain = this.showDomainName(test.url);
      if (test.taskResolvedAt) {
        const dateObject = new Date(test.taskResolvedAt);

        // Get current time
        const currentTime = new Date();

        // Calculate the time difference in milliseconds
        const timeDifference = currentTime - dateObject;

        // Convert time difference to hours
        const minutesDifference = timeDifference / (1000 * 60);
        if (minutesDifference <= 60) {
          return true
        }
      }
      return this.activeMigrationList.find(el => el.domain === domain) || this.activeJobsDomainList.find(el => (el.jobName !== 'set-php-version' && el.jobData.ip === test.serverIP))
    },
    checkPhpJob (test) {
      let domain = this.showDomainName(test.url);
      const obj = this.activeJobsDomainList.find(el => (el.jobName === 'set-php-version' && el.domain === domain))
      if (obj) {
        return true
      } else {
        const lastIncident = test.incidents[test.incidents.length - 1]
        if (!lastIncident.start) {
          return
        }
        const date = lastIncident.start
        let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
        const obj1 = this.completedJobsDomainList.find(el => {
          return el.jobName === 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate60Min) && (el.domain === domain)
        })
        return !!obj1
      }
    },
    checkCompletedJob (test) {
      const lastIncident = test.incidents[test.incidents.length - 1]
      if (!lastIncident.start) {
        return
      }
      const date = lastIncident.start
      let earlierDate = new Date(new Date(lastIncident.start).getTime() - (30 * 60 * 1000)).toISOString();
      let earlierDate60Min = new Date(new Date(lastIncident.start).getTime() - (60 * 60 * 1000)).toISOString();
      let domain = this.showDomainName(test.url);
      const obj = this.completedJobsDomainList.find(el => {
        return el.jobName !== 'set-php-version' && (el.createdAt <= date && el.createdAt >= earlierDate) && (el.jobData.ip === test.serverIP)
      })
      return !!obj
    },
    pendingJobs(){
      const allowedOperations = ['create', 'restore']
      const query = db.collection('jobLogs')
          .where('status', '==', 'running')
          .where('jobName', 'in', ['backup-job', 'staging-job', 'cloning', 'set-php-version'])
          .orderBy("createdAt", "desc");

      this.pendingJobListener =  query.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data()
          if (change.type === 'added') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.activeJobsDomainList.push({
                jobName: data.jobName,
                domain: data.inputDomain,
                operation: data.jobData.operation || '',
                jobData: data.jobData
              })
            }
          } else if (change.type === 'removed') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.activeJobsDomainList =  this.activeJobsDomainList.filter(d=> {
                return !(d.domain === data.inputDomain && d.jobName === data.jobName)
              })
            }
          }
        })
      });
    },
    activeMigrations () {
      const allowedStatus = ['pending']
      let ref = db
          .collection("savedMigrations")
          .where('status', 'in', allowedStatus)

      this.migrationListener =  ref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data()
          if (change.type === 'added') {
            this.activeMigrationList.push({
              domain: data.siteDetails.domainName,
              status: data.status || '',
            })
          } else if (change.type === 'removed') {
            this.activeMigrationList =  this.activeMigrationList.filter(d=> {
              return !(d.domain === data.siteDetails.domainName)
            })
          }
        })
      });
    },
    completedJobs(){
      let date = new Date()
      date.setDate(date.getDate() - 1);
      const allowedOperations = ['create', 'restore']
      const query = db.collection('jobLogs')
          .where('status', '==', 'complete')
          .where('jobName', 'in', ['backup-job', 'staging-job', 'cloning', 'set-php-version'])
          .where('createdAt', ">=", date.toISOString())
          .orderBy("createdAt", "desc");

      this.completeJobListener =  query.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const data = change.doc.data()
          if (change.type === 'added') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.completedJobsDomainList.push({
                jobName: data.jobName,
                domain: data.inputDomain,
                operation: data.jobData.operation || '',
                createdAt: data.createdAt,
                jobData: data.jobData
              })
            }
          } else if (change.type === 'removed') {
            if (data.jobName !== 'backup-job' || (data.jobName === 'backup-job' && allowedOperations.includes(data.jobData.operation))) {
              this.completedJobsDomainList =  this.completedJobsDomainList.filter(d=> {
                return !(d.domain === data.inputDomain && d.jobName === data.jobName)
              })
            }
          }
        })
      });
    },
    checkOption (event) {
      console.log(event)
      const { tag } = event.target._value;
      if (tag === 'all') {
        // check all tags
        if(this.selectedFilters && this.selectedFilters.length) {
          this.selectedFilters = []
          this.notInWPOFilter = false;
        } else {
          this.notInWPOFilter = true
          this.selectedFilters = this.filteredOptions.slice(1,-1)
        }
        console.log('selected filters',this.selectedFilters)
      }
      // else if(tag === 'none') {
      //   this.selectedFilters = []
      //   this.selectedFilters.push(this.filteredOptions[this.filteredOptions.length - 1])
      // } else {
      //   // remove all and none from array
      //   const index = this.selectedFilters.findIndex(el => el.tag === 'all' )
      //   if (index !== -1) {
      //     this.selectedFilters.splice(index, 1)
      //   }
      //   const noneIndex = this.selectedFilters.findIndex(el => el.tag === 'none' )
      //   if (noneIndex !== -1) {
      //     this.selectedFilters.splice(noneIndex, 1)
      //   }
      // }

    },
    changeCauseLength(test){
      this.$set(this.tracker, test.id, !this.tracker[test.id]);
      // if(this.tracker[test]){
      // }
      // else{
      //   this.$set(this.tracker, test.id, true);
      // }
      console.log('trackers', this.tracker)
    },
    getProperty(property) {
      return this.tracker[property] || false;
    },
    showDomainName (url) {
      let domainName = url.replace('https://', '').replace('/?v={timestamp}', '');
      // if (domainName.length > 22) {
      //   return [domainName.slice(0,22), domainName.slice(22,domainName.length)]
      // }
      domainName = domainName.split('/?')[0]
      return domainName

    },
    checkDownTime (test) {
      return (new Date() - new Date(test.incidents[test.incidents.length - 1].start))/60000
    },
    getScreenshotUrl (test) {
      return test.incidents[test.incidents.length - 1].screenshotUrl;
    },
    getEffectiveUrl (test) {
      return test.incidents[test.incidents.length - 1].effective_url || test.url;
    },
    getResponseUrl (test) {
      return test.incidents[test.incidents.length - 1].responseUrl || '';
    },
    getAcknowledgeBy (test) {
      if (test.incidents && test.incidents.length) {
        return test.incidents[test.incidents.length-1].acknowledgedBy || ''
        // const incidents = JSON.parse(JSON.stringify(test.incidents))
        // const obj = incidents.reverse().find(inc => !!inc.id);
        // if (obj && obj.acknowledgedBy) {
        //   return obj.acknowledgedBy
        // }
      }
      return false
    },
    async saveInDBAndShowSuccess(test, ack_by, noTicket) {
      // test.incidents[test.incidents.length - 1].acknowledgedBy = ack_by
      // const incidentId = test.incidents[test.incidents.length - 1].id
      // if (!incidentId) {
      // await db.collection('monitors').doc(test.id).update({
      //   incidents: test.incidents,
      //   lastAckBy: ack_by,
      //   LastAckAt: new Date().toISOString()
      // })
      // }

      this.selectedMonitorLoading= null
      if(!noTicket){
        // swal({
        //   title: 'Success!',
        //   text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
        //   type: 'success',
        //   showCancelButton: true,
        //   confirmButtonColor: "#6ACF98",
        //   cancelButtonColor: "#EE8057",
        //   confirmButtonText: "Yes Proceed",
        //   cancelButtonText: "No Thanks",
        // }).then((result) => {
        //   if(result.value) {
        //     this.openTicketModal(test, 'checkin')
        //   }
        // })
      }
    },
    async bulkAcknowledgeV2(group, acknowledgedBy, noIncrement=null){
      try{
        const encryptedEmail =  this.user.email ?  md5(this.user.email.trim().toLowerCase()).toString() : '';
        const result  = await this.$http.post('/monitor/bulk-acknowledge',{
          grant_type: 'token',
          group,
          acknowledgedBy,
          noIncrement, encryptedEmail
        });
        // swal({
        //   title: 'Success!',
        //   text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
        //   type: 'success',
        //   showCancelButton: true,
        //   confirmButtonColor: "#6ACF98",
        //   cancelButtonColor: "#EE8057",
        //   confirmButtonText: "Yes Proceed",
        //   cancelButtonText: "No Thanks",
        // }).then((result) => {
        //   if(result.value) {
        //     this.openTicketModal(group.tests[0], 'checkin')
        //   }
        // })
      }
      catch(e) {
        console.log('Error Occurred', e.toString())
      }
    },
    async bulkAcknowledge( group, acknowledgedBy, noIncrement){
      try {
        const firstCheckin = !group.tests.find(el => {
          return el.incidents[el.incidents.length - 1].acknowledgedBy
        });
        this.selectedPlanLoading= group.planName
        for(const row of group.tests){
          const lastObj = row.incidents[row.incidents.length - 1]
          if(!lastObj.acknowledgedBy && lastObj.status === 'down'){
            console.log('monitor to be processed', row.id)
            await this.acknowledge(row, acknowledgedBy, true)
          }
        }
        if (!noIncrement) {
          try{
            await this.incrementCountBasedOnType(this.user, 'monitor')
            const data= {
              ticketId: group.uid,
              taskId:  group.uid,
              type  : 'info',
              message: `${this.user.firstName} ${this.user.lastName} has checked in Monitor ${group.uid}.`,
              actionType: 'monitor',
              customer: {
                domain: group.uid,
              }
            }
            // await this.addToAdminActiveTask({...data})
            await this.addRecentActivity({...data})
          }catch (e) {
            console.log('line 1016', e.toString())
          }
        }
        if(firstCheckin){
          console.log('firstCheckin')
          // swal({
          //   title: 'Success!',
          //   text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
          //   type: 'success',
          //   showCancelButton: true,
          //   confirmButtonColor: "#6ACF98",
          //   cancelButtonColor: "#EE8057",
          //   confirmButtonText: "Yes Proceed",
          //   cancelButtonText: "No Thanks",
          // }).then((result) => {
          //   if(result.value) {
          //     this.openTicketModal(group.tests[0], 'checkin')
          //   }
          // })
        }
        this.selectedPlanLoading= null
      }catch (e) {
        this.selectedPlanLoading= null
        console.log('error while acknowledging', e.toString())
      }
    },
    async acknowledge(test, acknowledgedBy, noTicket) {
      // const incidents = JSON.parse(JSON.stringify(test.incidents))
      // const obj = incidents.reverse().find(inc => !!inc.id);
      const acknowledgedByName= acknowledgedBy ? acknowledgedBy : !noTicket ? this.user.firstName + ' ' + this.user.lastName : ''
      try{
        this.selectedMonitorLoading= test.id
        // save acknowledged by in db
        if (acknowledgedByName) {
          test.incidents[test.incidents.length - 1].acknowledgedBy = acknowledgedByName;
          await db.collection('monitors').doc(test.id).update({
            incidents: test.incidents
          })
        }
        // if(!obj) {
        //   swal({
        //     title: "Error!",
        //     text: 'No incident id exists!',
        //     type: "error",
        //     confirmButtonText: "Try Again!",
        //     confirmButtonColor: "#EE8057"
        //   });
        //   return false
        // }
        if(acknowledgedByName && !noTicket){
          if(!noTicket) {
            try{
              await this.incrementCountBasedOnType(this.user, 'monitor')
              try {
                const data= {
                  ticketId: test.id,
                  taskId:  test.id,
                  type  : 'info',
                  message: `${this.user.firstName} ${this.user.lastName} has checked in Monitor ${test.name}.`,
                  actionType: 'monitor',
                  customer: {
                    domain: this.showDomainName(test.url),
                  }
                }
                // await this.addToAdminActiveTask({...data})
                await this.addRecentActivity({...data})
              } catch (e) {
                console.log('unable to save recent activity', e.toString())
              }

            }catch (e) {
              console.log('line 1063', e.toString())
            }
          }
        }
      }catch (err){
        let errorMessage = 'Something went wrong while acknowledging the monitor';
        if (!err || !err.response || err.response.status !== 409 ) {
          test.incidents[test.incidents.length -1].acknowledgedBy = ''
          await db.collection('monitors').doc(test.id).update({ incidents: test.incidents})
          if(!noTicket) {
            swal({
              title: "Error!",
              text: errorMessage,
              type: "error",
              confirmButtonText: "Try Again!",
              confirmButtonColor: "#EE8057"
            });
          }
        }

      } finally {
        this.selectedMonitorLoading= null
      }

    },
    checkStatusCake (test, statusCake) {
      if ((test.status === 'up' || test.status === 'down') && statusCake.toLowerCase() === 'active') {
        return true
      } else if (!(test.status === 'up' || test.status === 'down')) {
        if (test.statusCake && test.statusCake.toLowerCase() === statusCake.toLowerCase()) {
          return true
        } else if (!test.statusCake && (test.status === 'up' || test.status === 'down') && statusCake.toLowerCase() === 'active') {
          return true
        } else if (!test.statusCake && test.status === 'paused' && statusCake.toLowerCase() === 'suspended') {
          return true
        } else if (!test.statusCake && test.status === 'pending' && statusCake.toLowerCase() === 'pending') {
          return true
        }
      }
      return false
    },
    async getStatusList(){
      this.statusList=[]
      const ref=await db.collection('permissions').doc('betteruptime-monitor-settings').get()
      if(ref.exists){
        this.statusList.push({status: 'Active'})
        this.statusList.push({status: 'Pending'})
        this.statusList=this.statusList.concat(ref.data().settings);
      }
    },
    async openTicketModal(group, from){
      this.loadingOfTicket = {flag: true, id: group.id};
      if(from === 'diskAlert'){
        const ref = await db.collection('permissions').doc('preset_macros_domain').get();
        if(ref.exists) {
          const { replies } = ref.data();
          console.log(`replies ${replies}`)
          const preset = [{...replies.find(el => el.title === 'Storage Overage')}];
          await this.$parent.$refs.ticketModal.load(preset, group, from)
        }
      }
    },
    openAffectedNodesAndRacksModal(type){
      this.$refs.nodes.load(this.affectedNodes, this.allNodes, type)
    },
    remove(test) {
      swal({
        title: "Are you sure?",
        text: `Are you sure you want to delete this test?`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
          .then(async result => {
            if (result.value){
              this.removeItem = test;
              this.action = 'remove';
              try{
                await db.collection('monitors').doc(test.id.toString()).delete();
                // await this.removeAdminActiveTask({taskId:test.id})
                // await this.startGrouping();
                this.addLog({
                  primaryPlan: 'Account Based Operation',
                  message: `Disk Alert has been deleted, TestId: ${test.id}, Test Name: ${test.url}`,
                  level: "info"
                })
              }catch(err){
                swal({
                  title: "Something went wrong!",
                  html: 'Something went wrong',
                  type: "error",
                  confirmButtonText: "Try Again!",
                  confirmButtonColor: "#EE8057"
                });
              } finally{
                this.action = null;
                this.removeItem = null;
              }
            }
          });
    },
    pause(test, pauseValue) {
      this.updateItem = test;
      this.action = 'update';
      this.$http.post("domain/update/monitor_test", {
        grant_type: "token",
        token: this.userToken,
        data: {
          testID: test.id,
          paused: pauseValue ==0 ? false: true
        }
      })
          .then(() => {
            if(pauseValue === 0) {
              console.log('Un - Pausing....');
              this.$http.post('/monitor/get_test', {
                grant_type: "token",
                token: this.userToken,
                testId: test.id,
              }).then(resp => {
                let testData = resp.data.test.data.attributes;
                console.log('testData', testData)
                if(!testData.ErrNo){
                  test.status = testData.status;
                  if(test.statusCake === 'Active'){
                    if(testData.paused){
                      test.statusCake = 'Other'
                    }
                    else if(test.status === 'pending'){
                      test.statusCake = '15Min'
                    }
                  }
                  if (testData.status !== 'paused') {
                    test.incidents[test.incidents.length - 1].end = new Date().toISOString();
                    test.incidents.push({
                      start: new Date().toISOString(),
                      status: testData.status,
                      statusCode: (testData.status === 'up') ? 200 : 0,
                    });
                  }
                  // test.upTime = testData.Uptime;
                  test.updatedAt = new Date().toISOString();
                  if (testData.status === 'down') {
                    test.downCount += 1;
                  }
                }
                console.log(test);
                db.collection('monitors').doc(test.id.toString()).update(test);

                this.addLog({
                  primaryPlan: 'Account Based Operation',
                  message: `Monitor test has been unpaused, TestId: ${test.id}, Test Name: ${test.name}`,
                  level: "info"
                })
              });
            }else{
              console.log('Pausing....');
              db.collection('monitors').doc(test.id.toString()).update({ status: 'paused' });
            }
          })
          .catch((err) => {
            console.error(err);
            let responseMessage = err.response.data.message;
            if (err.response.status === 422) {
              responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
            } else if (err.response.status === 401) {
              responseMessage = "You need update token. Please Try Again!";
              this.refreshToken();
            }
            swal({
              title: "Something went wrong!",
              html: responseMessage,
              type: "error",
              confirmButtonText: "Try Again!",
              confirmButtonColor: "#EE8057"
            });
            this.addLog({
              name: this.user.firstName + " " + this.user.lastName,
              message: "Error StatusCake pause. Message: " + responseMessage,
              level: "danger"
            });
          })
          .finally(() => {
            this.action = null;
            this.updateItem = null;
          });

    },
    updateStatusCakeValue(test, e){
      console.log(e.target.value);
      console.log(test);
      console.log('Adding status cake value in: ' + test.id);
      if(test.notes === undefined){
        test.notes = [];
      }
      test.notes.push({
        noteDate: new Date().toISOString(),
        note: e.target.value,
        noteAddedBy: this.user.firstName + ' ' + this.user.lastName
      });
      if (e.target.value.toLowerCase() === 'suspended') {
        test.note = 'Suspended'
      }
      test.statusCake = e.target.value;
      test.updatedAt = new Date().toISOString();
      db.collection('monitors').doc(test.id.toString())
          .update(test)
          .then(()=>{
            if(e.target.value.toLowerCase() === 'active') {
              const incidentId = test.incidents[test.incidents.length - 1].id;
              console.log('incidentId', incidentId)
              if (incidentId) {
                console.log('resolving incident')
                this.$http.post("monitor/resolve/incident", {
                  grant_type: "token",
                  token: this.userToken,
                  incidentId,
                  resolvedBy: `${this.user.firstName} ${this.user.lastName}`
                })
              }
              this.pause(test, 0);
            }else{
              this.pause(test, 1);
            }
          }).catch(() => {
        this.addLog({
          message: `Error in updating status cake value!`,
          level: "danger"
        })
        swal('Error', 'Error in updating status cake value!', 'error');
      });
    },
    clickedIpSort () {
      if (!this.ipSortType) {
        this.ipSortType = 'desc'
      } else if (this.ipSortType === 'desc') {
        this.ipSortType = 'asc'
      } else {
        this.ipSortType = null
      }
    },
    clickedDowntimeSort () {
      if (!this.downtimeType) {
        this.downtimeType = 'desc'
      } else if (this.downtimeType === 'desc') {
        this.downtimeType = 'asc'
      } else {
        this.downtimeType = null
      }
    },
    clickedOutageSort () {
      if (!this.outageSortType) {
        this.outageSortType = 'desc'
      } else if (this.outageSortType === 'desc') {
        this.outageSortType = 'asc'
      } else {
        this.outageSortType = null
      }
    },
    clickedRackSort () {
      if (!this.rackSortType) {
        this.rackSortType = 'desc'
      } else if (this.rackSortType === 'desc') {
        this.rackSortType = 'asc'
      } else {
        this.rackSortType = null
      }
    },
    clickedNodeSort () {
      if (!this.nodeSortType) {
        this.nodeSortType = 'desc'
      } else if (this.nodeSortType === 'desc') {
        this.nodeSortType = 'asc'
      } else {
        this.nodeSortType = null
      }
    },
    clickedPlanSort () {
      if (!this.planSortType) {
        this.planSortType = 'desc'
      } else if (this.planSortType === 'desc') {
        this.planSortType = 'asc'
      } else {
        this.planSortType = null
      }
    },
    clickedStatusSort () {
      if (!this.statusSortType) {
        this.statusSortType = 'desc'
      } else if (this.statusSortType === 'desc') {
        this.statusSortType = 'asc'
      } else {
        this.statusSortType = null
      }
    },
    nextPage(){
      this.pageNumber++;
    },
    prevPage(){
      this.pageNumber--;
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum-1;
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
    },
    getNoteTooltip(data){
      let tooltip=''
      if(data.noteAddedAt){
        tooltip+=moment(data.noteAddedAt).format("DD MMM, YYYY HH:mm:ss")
      }
      return tooltip
    },
    async getAllNodes(){
      try{
        let nodesResp=await  db.collection('netboxNodes').get()
        this.allNodes= {}
        nodesResp.forEach( el => {
          this.allNodes[el.id] = el.data()
          // this.allNodes.push({id:el.id, ...el.data()})
        })
      }catch(e){
        console.log('error', e.toString())
      }
    },
    doCopy(item){
      this.$copyText(item).then(() => {
        this.$notify({
          group: 'foo',
          title: 'Message',
          text: 'Copied!'
        });
      }, function (e) {
        console.log(e)
      });
    },
    async renderDatatable(group, type){
      group.showTests = !group.showTests
      if (type === 'openedGroups') {
        // let openedGroups = [];
        // if (localStorage.getItem('openedGroups')) {
        //   openedGroups = JSON.parse(localStorage.getItem('openedGroups'))
        // }
        if (group.showTests) {
          this.openedGroups.push(group.planName)
        } else {
          this.openedGroups.splice(this.openedGroups.indexOf(group.planName), 1)
        }
        // localStorage.setItem('openedGroups', JSON.stringify(openedGroups))
      }
      let self = this
      if(type=='ungrouped'){
        // $(`#${this.datatableId}-ungrouped`).DataTable().destroy();
        // setTimeout(function () {
        //   $(`#${self.datatableId}-ungrouped`).dataTable({
        //     // pagingType: "full_numbers",
        //     "bPaginate": false, //hide pagination
        //     "bFilter": false, //hide Search bar
        //     destroy: true,
        //     retrieve: true,
        //     deferRender: true,
        //     stateSave: true,
        //     "bInfo" : false,
        //     "ordering": false,
        //     // order: [[2, "asc"]],
        //     // 'columnDefs': [ {
        //     //   'targets': [0,1, -1,7], /* column index */
        //     //   'orderable': false, /* true or false */
        //     // }]
        //   });
        // }, 0)
      }
      // else{
      //   group.showTests = !group.showTests
      //   let id=group.planName==='(N/A)' ? `${this.datatableId}-unavailable` : `${this.datatableId}-${group.planName}`
      //   if(id.includes('.com')){
      //     id= id.split('.')[0]
      //   }
      //   if(group.showTests){
      //     if($.fn.DataTable.isDataTable( `#${id}`)){
      //       $(`#${id}`).DataTable().destroy()
      //
      //     }
      //     $(`#${id}`).dataTable({
      //       pagingType: "full_numbers",
      //       destroy: true,
      //       retrieve: true,
      //       deferRender: true,
      //       stateSave: true,
      //       "ordering": true,
      //       order: [[2, "asc"]],
      //       'columnDefs': [ {
      //         'targets': [0,1, -1,7], /* column index */
      //         'orderable': false, /* true or false */
      //       }]
      //     });
      //   }
      // }
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
    },
    getTotalOutages(group){
      return group.tests.reduce((a, b) => a + (b.downCount || 0), 0);
    },
    findUser(group){
      if (group.uid ) {
        // let customers = localStorage.getItem('customers') ? JSON.parse(localStorage.getItem('customers')) : [];
        // let user = find(customers, {'docID': uid});
        swal({
          title: group.firstName + ' ' + group.lastName,
          text: 'Would you like to login to this customer\'s WPO account',
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then( result => {
          if(result.value){
            this.goToNuxt(group.uid);
          }
        });
      } else {
        swal("Not Found!", 'Plan is not found in the WPO', 'error');
      }
    },
    openModal(test, el){
      if(el === 'viewEventsModal'){
        this.$parent.selectedItemForView = _.cloneDeep(test);
        this.$parent.eventsShowAll = false
        this.$parent.notesShowAll = false
        this.$parent.notesPageSize = 5
        this.$parent.notesPageNumber = 0
        this.$parent.pageNumber = 0
        this.$parent.pageSize = 5
        this.$parent.selectedItemForView.incidents.reverse();
        if(this.$parent.selectedItemForView.notes !== undefined){
          this.$parent.selectedItemForView.notes.reverse();
        }
        let durations = [];
        for(let event of this.$parent.selectedItemForView.incidents){
          if(event.status === 'down' && event.end !== undefined){
            let dur = this.timeDifferenceBetweenGivenDates(event.end, event.start);
            if(dur.split(':').length === 2){
              durations.push("00:" + dur);
            }else if(dur.split(':').length === 1){
              durations.push("00:00:" + dur);
            }else{
              durations.push(dur);
            }
          }
        }
        const totalDurations = moment.duration();
        durations.map(duration => {
          totalDurations.add(duration);
        });
        this.$parent.totalDownDurationOfSelectedItem = moment.utc(totalDurations.asMilliseconds()).format("HH:mm:ss");
      }
      else if(el === 'showTempUrl'){
        const domainRegex = /https?:\/\/([a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})/;
        const match = test.name.match(domainRegex);
        if (match) {
          const domain = match[1];
          this.$refs.tempDomainModal.load({
            domain,
            uid: test.uid,
            ip: test.serverIP,
            expiryTime: '1440'
          })
        } else {
          console.log("No domain found.");
        }

        $('.modal-backdrop').removeClass("modal-backdrop");
        return
      }
      else{
        this.$parent.selectedItemForView = test;
      }
      /* eslint-disable */
      $("#" + el).modal("show");
      $('.modal-backdrop').removeClass("modal-backdrop");
      /* eslint-enable */
    },
    startClockTicking(){
      for(let test of this.tests){
        this.domainDateTime[test.url] = this.timeDifferenceBetweenGivenDates(new Date().toISOString(), test.incidents[test.incidents.length-1].start);
        this.$forceUpdate();
      }
    },
    getAffectedNodes(array){
      this.affectedNodes=[]
      if(array.length>0){
        array.map(el => {
          if(el.netboxNodeId && el.status!=='paused'){
            let obj=this.affectedNodes.find(row => row.id && row.id===el.netboxNodeId)
            if(obj){
              obj.count++
            }
            else {
              this.affectedNodes.push({id: el.netboxNodeId, count:1})
            }
          }
        })
      }
    },
    getAffectedRacks(array){
      this.affectedRacks=[]
      if(array.length>0){
        array.map(el => {
          if(el.rackId && el.status!=='paused'){
            let obj=this.affectedRacks.find(row => row.id && row.id===el.rackId)
            if(obj){
              obj.count++
            }
            else {
              this.affectedRacks.push({id: el.rackId, count:1, nodeId:el.netboxNodeId || ''})
            }
          }
        })
      }
    },
    groupTestsInAPlan(tests){
      console.log("tests", tests.filter(el => el.type === 'diskAlert'))
      this.tests = _.cloneDeep(tests);
      this.searchQuery = ''
      // const testIps = ['69.162.173.212', '23.29.145.209']
      // this.tests = this.tests.filter(test => {
      //   return !testIps.includes(test.serverIP)
      // })
      // this.getPausedAndDownTests(_.cloneDeep(this.tests))
      // this.getAffectedNodes(_.cloneDeep(this.tests))
      // this.getAffectedRacks(_.cloneDeep(this.tests))
      // this.startGrouping()
      $('[data-toggle="tooltip"]').tooltip('dispose');
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    },
    getPausedAndDownTests(tests){
      this.totalPausedTests=0
      this.totalDownTests=0
      this.totalDownServices=0
      this.totalPendingTests=0
      this.totalSuspendedTests=0
      const countedIps = []
      tests.map(el => {
        if(el.status==='paused'){
          if (el.hbSuspended) {
            this.totalSuspendedTests++
          } else {
            this.totalPausedTests++
          }
        }
        else if(el.status==='down'){
          this.totalDownTests++
          console.log('!countedIps.includes(el.serverIP)', !countedIps.includes(el.serverIP), el)
          if (!countedIps.includes(el.serverIP)) {
            this.totalDownServices++
            countedIps.push(el.serverIP)
          }
        }
        else if(el.status==='pending'){
          this.totalPendingTests++
        }
      })

    },
    getRackName(name){
      if(name){
        let rack=name
        if(rack.includes('rack')){
          return rack.split('rack')[1]
        }else if(rack.includes('Rack')){
          return rack.split('Rack')[1]
        }
        else{
          return name
        }
      }
    },
    startGrouping () {
      console.log(this.tests, 'after tests')
      // const openedGroups = localStorage.getItem('openedGroups') ? JSON.parse(localStorage.getItem('openedGroups')) : []
      this.testGroups=[]
      // const testIps = ['69.162.173.2s12', '23.29.145.209']
      // this.tests = this.tests.filter(test => {
      //   return !testIps.includes(test.serverIP)
      // })
      this.tests.map(test => {
        console.log(`test type ${test.type}`)
        // const domainOwner = this.findOwnerOfDomain(test);
        const planName = test.type === 'diskAlert' ? 'diskAlert' :( test.hbSuspended ? 'Suspended' : ((test.plan) ? test.plan : ''));
        let group = this.testGroups.find(g => g.planName && g.planName === planName);
        test.acknowledgedBy= this.getAcknowledgeBy(test)
        test.showCause= false
        if(test.type === 'diskAlert') {
          group = {
            notInWPO: test.plan ? false : true,
            planName:  planName,
            serverIP: test.serverIP || '',
            uid: test.uid,
            tests: [],
            firstName: test.firstName,
            lastName: test.lastName,
            nodeName: (this.allNodes[`${test.netboxNodeId}`]) ? this.allNodes[`${test.netboxNodeId}`].name || '' : '',
            rackName: (this.allNodes[`${test.netboxNodeId}`]) ? (this.allNodes[`${test.netboxNodeId}`].rack ? this.allNodes[`${test.netboxNodeId}`].rack.name : '') : '',
            showTests: this.openedGroups.includes(planName),
            downCount: (test.status === 'down') ? 1 : 0,
            pauseCount: (test.status === 'paused') ? 1 : 0,
            pendingCount: (test.status === 'pending') ? 1 : 0,
            ...test
          };
          console.log('pushing')
          this.testGroups.push(group);
        } else if(group){
          const testExist = group.tests.find(t => (t.id === test.id));
          if(!testExist) {
            group.tests.push(test);
            if (test.status === 'down') {
              group.downCount += 1;
            } else if (test.status === 'paused') {
              group.pauseCount += 1;
            } else if (test.status === 'pending') {
              group.pendingCount += 1;
            }
          }else if(testExist && testExist.status !== test.status) {
            testExist.status = test.status;
            if(test.status === 'down'){
              group.pauseCount -= 1;
              group.downCount += 1;
            } else if (testExist.status === 'paused') {
              group.pauseCount += 1;
              group.downCount -= 1;
            }
          }
        }
      });
      this.testGroups.map(g => {
        if(g.tests.length === 1) {
          const isLastTestExist = this.tests.find(t => t.id === g.tests[0].id);
          if(!isLastTestExist) {
            this.testGroups = this.testGroups.filter(g1 => g1.planName !== g.planName);
          }
          g.downCounts= g.tests[0].downCount
          if (g.tests[0].status === 'down' && !g.tests[0].acknowledgedBy) {
            g.showCheckin = true
          }
        }else{
          g.acknowledgedByNames = [];
          g.showCheckin = false;
          if (this.status === 'Down') {
            g.tests.map(el => {
              if (el.acknowledgedBy) {
                if(!g.acknowledgedByNames.includes(el.acknowledgedBy)) {
                  g.acknowledgedByNames.push(el.acknowledgedBy)
                }
              } else {
                if(el.status === 'down') {
                  g.showCheckin = true
                }
              }
            })
          }
          console.log('show checkin', g.showCheckin)
          if (g.showCheckin) {

            // check if any down monitor and checked in
            const obj = g.tests.find(el => {
              const isAcknowledged = el.incidents[el.incidents.length - 1].acknowledgedBy;
              return el.status === 'down' && isAcknowledged
            })
            if (obj) {
              // g.tests.map(el => {
              //   const obj1 = el.incidents[el.incidents.length - 1]
              //   if (!obj1.acknowledgedBy && obj1.status === 'down') {
              //   }
              // })
              // const lastAckBy = obj.incidents[obj.incidents.length - 1].acknowledgedBy
              // this.bulkAcknowledge(g, lastAckBy, true)
              g.showCheckin = false;
            }
            // bring down monitors on top
            g.tests = g.tests.sort((a, b) =>
                a.status.localeCompare(b.status));
            // const latestObject = g.tests.reduce((latest, current) => {
            //   if (latest.LastAckAt && current.LastAckAt) {
            //     const latestDate = new Date(latest.LastAckAt);
            //     const currentDate = new Date(current.LastAckAt);
            //     return currentDate > latestDate ? current : latest;
            //   } else {
            //     return current.LastAckAt ? current : latest
            //   }
            // });
            // if (latestObject.LastAckAt) {
            //   const specificDate = new Date(latestObject.LastAckAt);
            //   const currentDate = new Date();
            //
            //   const diff = (currentDate.getTime() - specificDate.getTime()) / (60 * 1000); // difference in milliseconds
            //   if (diff < 10) {
            //     g.acknowledgedBy = latestObject.acknowledgedBy || ''
            //     g.showCheckin = false
            //     this.bulkAcknowledge(g, latestObject.acknowledgedBy, true)
            //   }
            // }
          }
          // const obj= g.tests.find(el => el.acknowledgedBy)
          // if(obj){
          //   if(this.status === 'Down'){
          //     g.acknowledgedBy = obj.acknowledgedBy || ''
          //     this.bulkAcknowledge(g, g.acknowledgedBy)
          //   }
          // }
          g.downCounts= this.getTotalOutages(g)
          if (g.downCount === 1 && (g.planName !=='(N/A)' && g.planName !== 'Suspended') ) {
            // if downCount is 1 then expand the plan
            this.openedGroups.push(g.planName)
            g.showTests = this.openedGroups.includes(g.planName)
          }
        }
        g.status=g.tests.find(el => el.status==='down') ? 'down' : 'paused'

      });
      if(this.status !== 'up') {
        // this.testGroups.sort((group1, group2) => (group1.downCount < group2.downCount) ? 1 : -1);
        this.testGroups = _.orderBy(this.testGroups, ['downCount'], ['desc']);
      }
      this.loading = false
      console.log('groups', this.testGroups)
      this.renderDatatable({}, 'ungrouped')
      // this.$nextTick(() => {
      //   console.log('disposing')
      //   // Dispose of old tooltips to avoid duplication
      //   $('[data-toggle="tooltip"]').tooltip('dispose');
      //
      //   // Reinitialize tooltips
      //   $(function () {
      //     $('[data-toggle="tooltip"]').tooltip()
      //   })
      // });
    }
  },
  beforeDestroy() {
    if (this.pendingJobListener) {
      this.pendingJobListener()
    }
    if (this.migrationListener) {
      this.migrationListener()
    }
    if (this.completeJobListener) {
      this.completeJobListener()
    }
  }
}
</script>

<style scoped>
table{
  //min-height: 120px!important;
  border-collapse: unset !important;
}

table td.domain {
  min-width: 100px; /* Adjust the minimum width as per your requirement */
  max-width: 0;
  text-overflow: revert;
}
.dropdown-toggle:after {
  display: none;
}
.sc-status {
  width: 20px;
  border-radius: 50%;
  height: 20px;
  display: inline-block;
}

.sc-status.down {
  background-color: #a51f1f;
}

.sc-status.up {
  background-color: #6aa529;
}

.sc-status.pause{
  background-color: #f29f3f;
}
.sc-status.pending{
  background-color: #66615B;
}

.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
  margin: 13px auto;
}

.details-control.shown {
  width: 15px!important;
  background: url('../../../assets/img/details_close.png') no-repeat center center;
}
.single-outage-table tr > th,td{
  padding: 4px 4px !important;
}
.single-outage-table tr > th{
  font-size: 12px !important;
  font-weight: 400 !important;
}
code{
  color: #007bff !important;
}
.eventsTable tbody tr td{
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.notesTable tbody tr td{
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.lh-3{
  line-height: 3;
}
.group-section{
  background: #f4f4f4;
}
.pagination{
  display: inline-flex !important;
}
.cursor-pointer {
  cursor: pointer !important;
}
.badge.p-4-4{
  padding: 3px 3px !important;
  border-radius: 0px;
}
.down-monitor-bg {
  background-color: #F9BFB3 !important;
}
.bg-light {
  background-color: rgba(251,198, 88, 0.1) !important;
}
.w-8 {
  width: 8%;
  height: 8%;
}
.w-6 {
  width: 6%;
  height: 6%;
}
.w-25 {
  width: 20% !important;
  height: 20% !important;
}
.fs-20 {
  font-size: 20px;
}

.settinds-btn, .settinds-btn:active, .settinds-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.settinds-btn:hover {
  background-color: black!important;
  color: white !important;
}
.filter-btn, .filter-btn:active, .filter-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.filter-btn:hover {
  background-color: black!important;
  color: white !important;
}
.table-responsive{
  overflow: visible !important;
  margin-bottom: 0px;
}
.text-uppercase{
  text-transform: uppercase;
}
</style>
